export default "__VITE_ASSET__Cz7uRbdc__"